import axios from "axios";

export const baseURL = process.env.REACT_APP_BACKEND_URL ?? '';

const isProd = process.env.NODE_ENV === 'production';
const credentials = btoa('staging:i87FLrDp');
const basicAuth = 'Basic ' + credentials;

export const Client = axios.create({
    baseURL: baseURL,
    headers: {
        Accept: 'application/json',
        Authorization: isProd ? basicAuth : '',
    },
});
